// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  hmr: false,
  apiUrl: 'https://api.azure.mvrdv.fstr.io/api/',
  firebase: {
    apiKey: 'AIzaSyAs20OmCdNosCYqtATLQpv5e2upswcjyR8',
    authDomain: 'mvrdv-1516106256360.firebaseapp.com',
    databaseURL: 'https://mvrdv-1516106256360.firebaseio.com',
    projectId: 'mvrdv-1516106256360',
    storageBucket: 'mvrdv-1516106256360.appspot.com',
    messagingSenderId: '147486962422',
    appId: '1:147486962422:web:27f5e9e122461d2a0df2d7',
  },
};
